"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./MarketoForm.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var _Select = _interopRequireDefault(require("../Select/Select"));
var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Checkbox = _interopRequireDefault(require("../../components/Checkbox/Checkbox"));
var _TextArea = _interopRequireDefault(require("../TextArea/TextArea"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class MarketoForm extends _react.Component {
  constructor() {
    super();
    this.state = {};
  }
  handleSubmit = e => {
    e.preventDefault();
    if (this.props.submitting) {
      return;
    }
    this.props.handleSubmit();
  };
  getEntry = name => {
    const entry = this.props.entries.find(entry => {
      return entry.name === name;
    });
    if (!entry) {
      return {};
    } else {
      return entry;
    }
  };
  renderInputs = () => {
    // Graceful failsafe //
    let {
      inputs
    } = this.props;
    if (!inputs) {
      inputs = [];
    }
    return inputs.reduce((accu, input, index) => {
      const entry = this.getEntry(input.name);
      const warning = this.checkForWarning(input);
      if (input.type === "text") {
        if (warning) {
          accu.push( /*#__PURE__*/_react.default.createElement(_TextInput.default, {
            label: input.name,
            placeholder: input.placeholder || "",
            inputChange: this.props.handleChange,
            value: entry.value || "",
            name: input.name,
            key: `marketo-form-input-${index}`,
            required: input.required,
            status: {
              className: "error"
            }
          }));
        } else {
          accu.push( /*#__PURE__*/_react.default.createElement(_TextInput.default, {
            label: input.name,
            placeholder: input.placeholder || "",
            inputChange: this.props.handleChange,
            value: entry.value || "",
            name: input.name,
            key: `marketo-form-input-${index}`,
            required: input.required
          }));
        }
      } else if (input.type === "dropdown") {
        accu.push( /*#__PURE__*/_react.default.createElement(_react.Fragment, {
          key: `marketo-form-input-${index}`
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "ter-form-item__label luna-marketo-form__dropdown-label"
        }, input.name, " ", input.required && /*#__PURE__*/_react.default.createElement("span", {
          className: "ter-form-item__label-required-tag"
        }, " *")), /*#__PURE__*/_react.default.createElement(_Select.default, {
          name: input.name,
          options: input.options,
          handleSelection: this.props.handleSelect,
          defaultText: input.defaultText,
          selection: entry.value || null,
          warning: warning
        })));
      } else if (input.type === "text area") {
        accu.push( /*#__PURE__*/_react.default.createElement(_TextArea.default, {
          label: input.name,
          placeholder: input.placeholder || "",
          inputChange: this.props.handleChange,
          value: entry.value || "",
          name: input.name,
          key: `marketo-form-text-area-input-${index}`,
          required: input.required,
          status: {
            className: "error"
          }
        }));
      }
      return accu;
    }, []);
  };
  checkForWarning = _ref => {
    let {
      name
    } = _ref;
    const warnings = this.props.warnings || [];
    return warnings.includes(name);
  };
  render() {
    const {
      checkbox,
      optin,
      handleCheckboxChange,
      submissionAgreementText,
      reCAPTCHASiteKey,
      reCAPTCHAChange,
      reCAPTCHAExpiration
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("form", {
      className: "luna-marketo-form",
      onSubmit: e => this.handleSubmit(e)
    }, this.renderInputs(), submissionAgreementText && /*#__PURE__*/_react.default.createElement("p", {
      className: "luna-marketo-form__submission-agreement-text"
    }, submissionAgreementText), checkbox && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      label: checkbox.label,
      name: checkbox.name,
      checked: optin || false,
      handleChange: e => handleCheckboxChange(e)
    }), reCAPTCHASiteKey && reCAPTCHAChange && /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
      sitekey: reCAPTCHASiteKey,
      onChange: reCAPTCHAChange,
      onExpired: reCAPTCHAExpiration
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "ter-button--primary--1",
      text: "Submit",
      onClick: () => {}
    }), this.props.warnings && this.props.warnings.length >= 1 && this.props.warningText && /*#__PURE__*/_react.default.createElement("p", {
      className: "luna-marketo-form__warning-text"
    }, this.props.warningText), this.props.submitting && /*#__PURE__*/_react.default.createElement("p", {
      className: "luna-marketo-form__submitting-text"
    }, this.props.submittingText || "Submitting..."));
  }
}
var _default = MarketoForm;
exports.default = _default;
MarketoForm.propTypes = {
  inputs: _propTypes.default.array,
  handleSelect: _propTypes.default.func.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  entries: _propTypes.default.array.isRequired,
  warnings: _propTypes.default.array.isRequired,
  warningText: _propTypes.default.string,
  submissionAgreeementText: _propTypes.default.string
};